// extracted by mini-css-extract-plugin
export default {"coinCells":"coin-cell_coinCells__nu2w1"};